/**
 * Utility for cleaning URL parameters after share data is loaded
 */

export class UrlCleaner {
  /**
   * Cleans the URL by removing share data parameters while preserving other important parameters
   * This improves UX by hiding the long encoded data from the address bar
   */
  static cleanUrl(): void {
    try {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      
      // Remove share data parameters
      const paramsToRemove = ['data', 'encrypted'];
      let hasChanges = false;
      
      paramsToRemove.forEach(param => {
        if (params.has(param)) {
          params.delete(param);
          hasChanges = true;
        }
      });
      
      // Only update the URL if we actually removed parameters
      if (hasChanges) {
        // Build new URL with cleaned parameters
        const newSearch = params.toString();
        const newUrl = newSearch 
          ? `${url.pathname}?${newSearch}`
          : url.pathname;
        
        // Update the URL without triggering a page reload
        window.history.replaceState({}, '', newUrl);
        
        console.log('[UrlCleaner] Cleaned URL parameters');
      }
    } catch (error) {
      console.error('[UrlCleaner] Failed to clean URL:', error);
    }
  }

  /**
   * Checks if the current URL contains share data parameters
   * @returns true if share data parameters are present
   */
  static hasShareData(): boolean {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.has('data') || params.has('encrypted');
    } catch {
      return false;
    }
  }
}
